import { render, staticRenderFns } from "./TotemProductShowcase.vue?vue&type=template&id=e5365814&scoped=true"
import script from "./TotemProductShowcase.vue?vue&type=script&lang=js"
export * from "./TotemProductShowcase.vue?vue&type=script&lang=js"
import style0 from "./TotemProductShowcase.vue?vue&type=style&index=0&id=e5365814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5365814",
  null
  
)

export default component.exports